import gsap from 'gsap'

import { scrollTo } from '../initScrollTo'
import { isVisible, createEvent } from '../_helpers'
import {
  phoneMask,
  apiRequest,
  handleError,
  setInitialValues,
  setRequireAttributeForInputs,
} from './utils'

class StepForm {
  constructor(form) {
    this.form = form
    this.steps = form.querySelectorAll('[data-step]')
    this.inputs = form.querySelectorAll('input')
    this.progressBar = document.querySelector('.progress-line')
    this.progressValue = document.querySelector('.progress-data>span')
    this.startIndex = 0
  }

  init() {
    this.initNavigation()

    if (this.form.tel) {
      this.initTelInput()
    }

    this.disableFormSubmitOnEnterKey()
    this.initToggleSections()

    if (this.prefill) {
      // this should be done after initToggleSections !
      setInitialValues(this.form)
    }

    this.form.addEventListener('submit', e => {
      e.preventDefault()

      const submitBtn = this.form.querySelector('[type="submit"]')
      submitBtn.disabled = true
      apiRequest('auth', 'validatetoken', {
        MobileNr: this.form.tel.value,
        Token: this.form.code.value,
      }).then(() => {
        const action = this.isEfh() ? 'efh' : 'ewg'
        fetch(`/estimation/result-fpre/${action}`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.createPayload()),
        }).then(res => {
          if (res.ok) {
            res.text().then(html => {
              const doc = new DOMParser().parseFromString(html, 'text/html')
              const resultElem = doc.getElementById('estimation-result')
              this.success(
                resultElem?.outerHTML ||
                  'Merci! Vérifiez votre boîte aux lettres'
              )
            })
          } else {
            handleError(res, "Échec de l'estimation (erreur de serveur)")
          }
          submitBtn.disabled = false
        })
      })
    })

    // const el = this.form.querySelector('[name="type"][value="house"]')
    // if (el) {
    //   el.checked = true
    //   el.dispatchEvent(new Event('change'))
    //   el.dispatchEvent(new Event('input'))
    // }
  }

  isEfh() {
    return this.form.type.value === 'house'
  }

  createPayload() {
    const payload = {
      SPRACHE: '2', // "FR"
    }

    const isEfh = this.isEfh()

    // step map
    payload.OBJSTR = this.form.street.value
    payload.OBJNR = this.form.streetNumber.value
    payload.ORTLIEG = this.form.locality.value
    payload.PLZLIEG = this.form.zip.value
    payload.GEOWGS84LAT = this.form.latitude.value
    payload.GEOWGS84LNG = this.form.longitude.value

    // step use types
    if (isEfh) {
      payload.GEBARTC = '1'
    } else {
      payload.GEBARTC = this.form.usetype.value
    }

    // step house type / apartment type
    if (isEfh) {
      payload.ARTEFHC = this.form.subtype.value
    } else {
      payload.AREWGC = this.form.subtype.value
    }

    // step details
    if (isEfh) {
      payload.LAND = this.form['land-area'].value
      payload.VOL = this.form.building.value
      payload.ZIZ = this.form['rooms-house'].value
      payload.WOHNFL = this.form['area-house'].value
    } else {
      payload.ZIZ = this.form['rooms-apartment'].value
      payload.WOHNFL = this.form['area-apartment'].value
    }

    // step details part 2
    payload.BAUJ = this.form.year.value
    payload.STAND = this.form.standard.value
    payload.ZUST = this.form.condition.value

    // step contact information
    payload.Mobile = this.form.tel.value

    // step verification
    payload.Mobile_Code = this.form.code.value

    payload.Contact_Info = {
      title: this.form.title.value,
      surname: this.form.surname.value,
      name: this.form.name.value,
      tel: this.form.tel.value,
      email: this.form.email.value,
      reason: this.form.reason.value,
    }

    return payload
  }

  success(successHtml = '') {
    const pageTitle = document.getElementById('estimation-page-title')
    const self = this

    scrollTo(0, { duration: 0.5, headerOffset: false })

    gsap.to(pageTitle, {
      duration: 0.4,
      autoAlpha: 0,
      onComplete() {
        self.updateProgress(self.steps.length)
        self.progressValue.innerHTML = `
         <svg width="16" height="16" fill="none">
           <path d="M2.5498 7.65005L6.2498 11.35L13.5498 4.05005" stroke="#1E713F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
         </svg>
        `
        // idk but timeline doesnt work
        gsap.to(pageTitle, {
          duration: 0.4,
          height: 0,
        })
      },
    })

    const formParent = this.form.parentElement
    const tl2 = gsap.timeline()
    tl2.add(formParent, {
      duration: 0.4,
      autoAlpha: 0,
    })
    tl2.call(() => {
      formParent.innerHTML = successHtml
    })
    tl2.add(
      formParent,
      {
        duration: 0.4,
        autoAlpha: 1,
      },
      '+=0.4'
    )
  }

  validateInputBlock(block) {
    const blockInputs = Array.from(block.querySelectorAll('input[required]'))
    const errorMessage = block.querySelector('[data-error-message]')

    if (
      blockInputs.length &&
      !blockInputs.some(input => input.checkValidity())
    ) {
      gsap.to(errorMessage, {
        opacity: 1,
        duration: 0.5,
      })

      return block
    }

    gsap.to(errorMessage, {
      opacity: 0,
      duration: 0.5,
    })

    return undefined
  }

  validateInputBlocks(index) {
    const step = this.steps[index]
    const blocks = []
    const inputBlocks = step.querySelectorAll('[data-validateable-block]')

    inputBlocks.forEach(block => {
      blocks.push(this.validateInputBlock(block))
    })
    const invalidBlocks = blocks.filter(el => el && isVisible(el))

    if (invalidBlocks.length) {
      scrollTo(invalidBlocks[0].offsetTop, { headerOffset: true })
    }

    return !invalidBlocks.length
  }

  disableFormSubmitOnEnterKey() {
    this.inputs.forEach(input => {
      input.addEventListener('keydown', e => {
        if (e.keyCode === 13) {
          e.preventDefault()
          e.target.dispatchEvent(createEvent('change'))
        }
      })
    })
  }

  initToggleSections() {
    const toggleInputs = [...this.inputs].filter(input =>
      input.hasAttribute('data-toggle-for')
    )
    const toggleSections = [...this.form.querySelectorAll('[data-toggle]')]

    toggleInputs.forEach(input => {
      input.addEventListener('change', () => {
        toggleSections.forEach(section => {
          const isActive = section.dataset.toggle === input.dataset.toggleFor
          setRequireAttributeForInputs(section, isActive)
          section.style.display = isActive ? '' : 'none'
        })
      })
    })

    toggleSections.forEach(section => {
      section.style.display = 'none'
      setRequireAttributeForInputs(section, false)
    })
  }

  initTelInput() {
    const phoneValueBlocks = document.querySelectorAll(
      '[data-phone-number-value]'
    )

    const setPhoneValue = val => {
      phoneValueBlocks.forEach(el => {
        el.textContent = val
      })
    }

    this.form.tel.addEventListener('keyup', () => phoneMask(this.form.tel))
    this.form.tel.addEventListener('paste', () => phoneMask(this.form.tel))
    this.form.tel.addEventListener('change', e => {
      phoneMask(this.form.tel)
      setPhoneValue(e.target.value)
    })

    setPhoneValue(this.form.tel.value)
  }

  initNavigation() {
    this.steps.forEach((step, i) => {
      const prevBtn = step.querySelector('[data-prev]')
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          if (this.isEfh() && i === 3) {
            this.showStep(1)
          } else {
            this.showStep(i - 1)
          }
        })
      }

      const nextBtn = step.querySelector('[data-next]')
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const isValid = this.validateInputBlocks(i)
          if (!isValid) return

          const goNext = () => {
            if (this.isEfh() && i === 1) {
              this.showStep(3)
            } else {
              this.showStep(i + 1)
            }
          }

          if ('validatePhone' in nextBtn.dataset) {
            nextBtn.disabled = true
            apiRequest('auth', 'SendToken', {
              MobileNr: this.form.tel.value,
              Lng: 'FR',
            }).then(res => {
              if (res.ok) {
                goNext()
              } else {
                handleError(
                  res,
                  'La validation du téléphone a échoué (erreur de serveur)'
                )
              }
              nextBtn.disabled = false
            })
          } else {
            goNext()
          }
        })
      }

      step
        .querySelectorAll('input[required], select[required]')
        .forEach(input => {
          input.addEventListener('change', () => {
            const inputBlock = input.closest('[data-validateable-block]')
            if (inputBlock) {
              this.validateInputBlock(inputBlock)
            }
          })
        })
    })

    this.showStep(this.startIndex, true)
  }

  hideAllSteps(immediate = false) {
    this.steps.forEach(step => {
      if (immediate) {
        gsap.set(step, {
          display: 'none',
        })

        return
      }

      gsap
        .timeline()
        .to(step, {
          opacity: 0,
          duration: 0.4,
        })
        .set(step, {
          display: 'none',
        })
    })
  }

  showStep(index, immediate = false) {
    this.hideAllSteps(immediate)

    const el = this.steps[index]
    const tl = gsap.timeline()

    tl.set(el, {
      display: 'block',
    }).to(el, {
      opacity: 1,
      display: 'block',
      duration: 0.4,
    })

    this.scrollToStepTop(index)
    this.updateProgress(index)
  }

  scrollToStepTop(index) {
    const el = this.steps[index]
    const y = el.offsetTop

    scrollTo(y, { duration: 0.8, headerOffset: true })
  }

  updateProgress(currentIndex) {
    const calcPercentage = (currentIndex / this.steps.length) * 100

    this.progressBar.style.width = `${calcPercentage}%`
    this.progressValue.innerHTML = `${Math.round(calcPercentage)}%`

    gsap.to(document.querySelector('.progress-data'), {
      x: this.progressBar.offsetWidth - 32,
    })
  }
}

export default StepForm
